import React from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';

interface MenuItemProps {
    icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
    text: string;
    link: string;
    onClick?: () => void;
};

const MenuItem: React.FC<MenuItemProps> = (props: MenuItemProps) => {

    const [t] = useTranslation();
    const IconComponent = props.icon;

    return(
        <>
            <li>
                <NavLink to={props.link} activeClassName="active" onClick={props.onClick}>
                    <span className="main-menu__icon">
                        <IconComponent />
                    </span>
                    <span>{t(props.text)}</span>
                </NavLink>
            </li>
        </>
    );

};

export default React.memo(MenuItem);
